import { ibanApi } from '@api';
import { IBAN_MAX_LENGTH, IBAN_MIN_LENGTH, IBAN_REGEX_EU } from '@constants';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 400;

const useValidateIBAN = (iban: string) => {
  const [debouncedIban, setDebouncedIban] = useState(iban);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebouncedIban(iban), DEBOUNCE_MS);
    return () => window.clearTimeout(timer);
  }, [iban]);

  const normalized = debouncedIban?.replace(/\s/g, '') ?? '';
  const isValidLength = normalized.length >= IBAN_MIN_LENGTH && normalized.length <= IBAN_MAX_LENGTH;
  const isValidFormat = IBAN_REGEX_EU.test(debouncedIban.toUpperCase());

  return useQuery({
    queryKey: ['iban', debouncedIban],
    queryFn: () => ibanApi.validate(debouncedIban),
    enabled: isValidLength && isValidFormat,
    refetchOnMount: 'always',
  });
};

export default useValidateIBAN;
